import React from 'react';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import ScreenContainer from '@sdk/login/components/layout/ScreenContainer';
import H2 from '@sdk/components/ui/typography/H2';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import { LayoutWithImage } from '../components/LayoutWithImage';
import SlingToastSvg from '../assets/sling-toast.svg';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmationScreen = ({ onConfirm, onCancel }: Props) => (
  <LayoutWithImage image={<SlingToastSvg />}>
    <ScreenContainer>
      <Row top={0}>
        <H2 themeColor={ThemeColorType.primaryText}>{gettext('Please confirm')}</H2>
      </Row>
      <Row top={20}>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext('Are you sure you want to sync your Toast account to Sling?')}
        </Text14>
      </Row>
      <Row top={20}>
        <ProgressButton
          buttonType={ButtonType.primary}
          fontWeight="bold"
          onClick={onConfirm}
          height={42}>
          {gettext('Connect')}
        </ProgressButton>
      </Row>
      <Row top={20}>
        <ProgressButton
          buttonType={ButtonType.secondary}
          fontWeight="bold"
          onClick={onCancel}
          height={42}>
          {gettext('Go back')}
        </ProgressButton>
      </Row>
    </ScreenContainer>
  </LayoutWithImage>
);
